import { AppCtaButtons } from "components";
import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

type Props = ComponentProps<"section">;

export default function DownloadBox({ className, children, ...props }: Props) {
  return (
    <section className={twMerge("space-y-8", className)} {...props}>
      <p className="text-sm text-[#353740] font-medium text-center">
        You can download the last version of LinksRoom
        <br />
        from here to get a better experience:
      </p>
      <AppCtaButtons badgeVariant="svg" />
    </section>
  );
}
